export default __webpack_public_path__ + "static/HealthExamination-fcee091605e7dead28b117b1acc31630.pdf";